module.exports = __webpack_public_path__ + "img/error.36444a93.svg";